import { AfterContentInit, Component, ElementRef, Input, inject } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-show-more',
  imports: [NgClass, NgStyle, TranslateModule],
  templateUrl: './show-more.component.html',
  styleUrls: ['./show-more.component.scss'],
})
export class ShowMoreComponent implements AfterContentInit {
  private el = inject(ElementRef);
  @Input() active?: boolean;
  @Input() visible: number = 5;
  @Input('mobile-only') mobileOnly?: boolean;
  @Input('margin-left') marginLeft?: number;
  public count: number = 0;

  toggle(): void {
    this.active = !this.active;
    this.showHide();
  }

  showHide(): void {
    this.count = this.el.nativeElement.querySelectorAll('app-show-more-item').length;
    this.el.nativeElement.querySelectorAll('app-show-more-item').forEach((item: HTMLElement, index: number) => {
      if (index < this.visible) {
        item.style.display = 'block';
      } else {
        item.style.display = this.active ? 'block' : 'none';
      }
    });
  }

  ngAfterContentInit(): void {
    this.showHide();
  }
}
